import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const authTabsList = style([
  {
    marginTop: space.s20,
    gap: 0,
  },
]);

export const authTabItem = style([
  typography.bodyLg,
  {
    flexBasis: '50%',
    justifyContent: 'center',
    padding: space.s20,
    selectors: {
      '&[data-disabled], &[data-disabled]:hover': {
        color: themeVars.tab.foreground.disabled,
        cursor: 'not-allowed',
      },
    },
  },
]);
